<template>
    <!-- Admin → Marketing → Partners (/admin/marketing/partners). Mismo diseño
         que Admin → Usuarios / Modelos (bkCuenta + cuentaMenu + usuariosAdmin.css)
         y marketingAdmin.css (prefijo mk-).

         Datos: GET admin/marketing/partners?periodo=7d|30d|90d|mes|mes_anterior|todo
         (MarketingPartnersController). Por partner:
           mail        clics en su link del correo (hoy PAX, en el acuse del
                       formulario de llegada) → personas, clics y enviados; null
                       si el partner no tiene link en ningún correo.
           elegido     intakes que lo marcaron en "¿Te recomendó un partner?"
           con_codigo  sesiones que abrieron el formulario con su código en el link -->
    <div class="mk-page">
        <div class="bk us mk">
            <aside class="bk-side us-side">
                <router-link :to="{ name: 'admin' }" class="us-back">
                    <span aria-hidden="true" v-html="IC.back"></span>{{ $t('admin_marketing.back') }}
                </router-link>
                <p class="mk-kicker">{{ $t('admin_marketing.kicker') }}</p>
                <h1 class="bk-title">{{ $t('admin_marketing.title_a') }} <span class="bk-grad">{{ $t('admin_marketing.title_b') }}</span></h1>
                <p class="bk-subtitle">{{ $t('admin_marketing.sub') }}</p>

                <div class="us-stats mk-stats" aria-live="polite">
                    <div class="us-stat">
                        <span class="us-stat-n">{{ cifra(tot.mail.personas) }}</span>
                        <span class="us-stat-k">{{ $t('admin_marketing.stat.mail') }}</span>
                    </div>
                    <div class="us-stat">
                        <span class="us-stat-n">{{ cifra(tot.elegido) }}</span>
                        <span class="us-stat-k">{{ $t('admin_marketing.stat.picked') }}</span>
                    </div>
                    <div class="us-stat">
                        <span class="us-stat-n">{{ cifra(tot.con_codigo) }}</span>
                        <span class="us-stat-k">{{ $t('admin_marketing.stat.code') }}</span>
                    </div>
                    <div class="us-stat">
                        <span class="us-stat-n">{{ cifra(tot.partners) }}</span>
                        <span class="us-stat-k">{{ $t('admin_marketing.stat.partners') }}</span>
                    </div>
                </div>

                <div class="us-care mk-how">
                    <h2>{{ $t('admin_marketing.how.t') }}</h2>
                    <ul>
                        <li v-for="h in como" :key="h.k">
                            <span class="mk-how-ic" aria-hidden="true" v-html="h.ic"></span>
                            <span><b>{{ $t(`admin_marketing.how.${h.k}_t`) }}</b>{{ $t(`admin_marketing.how.${h.k}_d`) }}</span>
                        </li>
                    </ul>
                </div>
            </aside>

            <section class="us-main mk-main" :aria-busy="String(cargando)" aria-labelledby="mk-title">
                <h2 id="mk-title" class="us-sr">{{ $t('admin_marketing.title_a') }} {{ $t('admin_marketing.title_b') }}</h2>

                <div class="us-toolbar mk-toolbar">
                    <div class="mk-tool-row">
                        <div class="us-seg us-seg--sm mk-periods" role="group" :aria-label="$t('admin_marketing.period.label')">
                            <button v-for="p in PERIODOS" :key="p" type="button" :class="{ 'is-on': periodo === p }" :aria-pressed="String(periodo === p)" @click="elegirPeriodo(p)">{{ $t(`admin_marketing.period.${PER_KEY[p] || p}`) }}</button>
                        </div>
                        <button type="button" class="bk-btn bk-btn--ghost mk-reload" :disabled="cargando" @click="cargar">
                            <span aria-hidden="true" :class="{ 'mk-spin': cargando }" v-html="IC.reload"></span>{{ $t('admin_marketing.reload') }}
                        </button>
                    </div>
                    <div class="mk-tool-row">
                        <label class="us-search mk-search">
                            <span class="us-sr">{{ $t('admin_marketing.search_label') }}</span>
                            <span aria-hidden="true" v-html="IC.search"></span>
                            <input v-model="q" type="search" autocomplete="off" spellcheck="false" :placeholder="$t('admin_marketing.search_ph')" @keydown.esc="q = ''" />
                        </label>
                        <p v-if="rangoTxt" class="mk-range">{{ rangoTxt }}</p>
                    </div>
                </div>

                <div v-if="sinTabla" class="us-note us-note--warn mk-note" role="alert">
                    <b>{{ $t('admin_marketing.no_table.t') }}</b>
                    <span>{{ $t('admin_marketing.no_table.p') }} <code>database/migrations/querys/marketing_evento.sql</code></span>
                </div>

                <div v-if="error" class="us-empty">
                    <h3>{{ $t('admin_marketing.error_t') }}</h3>
                    <p>{{ $t('admin_marketing.error_p') }}</p>
                    <button type="button" class="bk-btn bk-btn--ghost" @click="cargar">{{ $t('admin_marketing.retry') }}</button>
                </div>

                <div v-else-if="cargando && !cargado" class="mk-loading"><HyFLoader variant="inline" /></div>

                <template v-else>
                    <!-- Las tres cifras del período -->
                    <ul :class="['mk-kpis', { 'is-cargando': cargando }]">
                        <li class="mk-kpi">
                            <span class="mk-kpi-ic" aria-hidden="true" v-html="IC.mail"></span>
                            <div class="mk-kpi-t">
                                <span class="mk-kpi-k">{{ $t('admin_marketing.kpi.mail') }}</span>
                                <span class="mk-kpi-n">{{ cifra(tot.mail.personas) }}</span>
                                <span class="mk-kpi-s">{{ $tc('admin_marketing.kpi.mail_s', tot.mail.clics, { n: cifra(tot.mail.clics) }) }}<template v-if="tot.mail.enviados"> · {{ $t('admin_marketing.kpi.rate', { p: tasa(tot.mail.personas, tot.mail.enviados), e: cifra(tot.mail.enviados) }) }}</template></span>
                            </div>
                        </li>
                        <li class="mk-kpi">
                            <span class="mk-kpi-ic" aria-hidden="true" v-html="IC.check"></span>
                            <div class="mk-kpi-t">
                                <span class="mk-kpi-k">{{ $t('admin_marketing.kpi.picked') }}</span>
                                <span class="mk-kpi-n">{{ cifra(tot.elegido) }}</span>
                                <span class="mk-kpi-s">{{ $t('admin_marketing.kpi.picked_s') }}</span>
                            </div>
                        </li>
                        <li class="mk-kpi">
                            <span class="mk-kpi-ic" aria-hidden="true" v-html="IC.link"></span>
                            <div class="mk-kpi-t">
                                <span class="mk-kpi-k">{{ $t('admin_marketing.kpi.code') }}</span>
                                <span class="mk-kpi-n">{{ cifra(tot.con_codigo) }}</span>
                                <span class="mk-kpi-s">{{ $t('admin_marketing.kpi.code_s') }}</span>
                            </div>
                        </li>
                    </ul>

                    <!-- Tabla por partner -->
                    <section :class="['mk-card', { 'is-cargando': cargando }]" aria-labelledby="mk-t-title">
                        <header class="mk-card-head">
                            <h3 id="mk-t-title">{{ $t('admin_marketing.table.title') }}</h3>
                            <span class="mk-card-n" aria-live="polite">{{ $tc('admin_marketing.table.count', filas.length, { n: cifra(filas.length) }) }}</span>
                        </header>

                        <div v-if="!partners.length" class="mk-empty">
                            <h4>{{ $t('admin_marketing.table.none_t') }}</h4>
                            <p>{{ $t('admin_marketing.table.none_p') }}</p>
                        </div>
                        <div v-else-if="!filas.length" class="mk-empty">
                            <h4>{{ $t('admin_marketing.table.none_q', { q: q.trim() }) }}</h4>
                            <button type="button" class="bk-btn bk-btn--ghost" @click="q = ''">{{ $t('admin_marketing.table.clear') }}</button>
                        </div>

                        <div v-else class="mk-table-w">
                            <table class="mk-table">
                                <caption class="us-sr">{{ $t('admin_marketing.table.caption', { r: rangoTxt || $t('admin_marketing.period.todo') }) }}</caption>
                                <thead>
                                    <tr>
                                        <th v-for="c in COLS" :key="c" scope="col" :class="`mk-th--${c}`" :aria-sort="orden.col === c ? (orden.dir > 0 ? 'ascending' : 'descending') : null">
                                            <button type="button" class="mk-sort" @click="ordenar(c)">
                                                {{ $t(`admin_marketing.col.${c}`) }}
                                                <span :class="['mk-sort-ic', { 'is-on': orden.col === c, 'is-up': orden.col === c && orden.dir > 0 }]" aria-hidden="true" v-html="IC.sort"></span>
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="f in filas" :key="f.id || f.clave">
                                        <th scope="row" class="mk-td-name">
                                            <span class="mk-av" aria-hidden="true">{{ inicial(f.nombre) }}</span>
                                            <span class="mk-name">
                                                <b>{{ f.nombre }}</b>
                                                <span v-if="!f.en_lista" class="mk-tag mk-tag--out" :title="$t('admin_marketing.tag.out_hint')">{{ $t('admin_marketing.tag.out') }}</span>
                                                <span v-else-if="!f.activo" class="mk-tag mk-tag--off" :title="$t('admin_marketing.tag.off_hint')">{{ $t('admin_marketing.tag.off') }}</span>
                                            </span>
                                        </th>
                                        <td :data-label="$t('admin_marketing.col.mail')">
                                            <template v-if="f.mail">
                                                <span class="mk-num">{{ cifra(f.mail.personas) }}</span>
                                                <span class="mk-sub">{{ $tc('admin_marketing.kpi.mail_s', f.mail.clics, { n: cifra(f.mail.clics) }) }}<template v-if="f.mail.enviados"> · {{ tasa(f.mail.personas, f.mail.enviados) }}</template></span>
                                                <span class="mk-bar" aria-hidden="true"><i :style="{ width: barra(f.mail.personas, 'mail') }"></i></span>
                                            </template>
                                            <span v-else class="mk-none" :title="$t('admin_marketing.table.no_mail')">—<span class="us-sr">{{ $t('admin_marketing.table.no_mail') }}</span></span>
                                        </td>
                                        <td :data-label="$t('admin_marketing.col.elegido')">
                                            <span class="mk-num">{{ cifra(f.elegido) }}</span>
                                            <span class="mk-bar" aria-hidden="true"><i :style="{ width: barra(f.elegido, 'elegido') }"></i></span>
                                        </td>
                                        <td :data-label="$t('admin_marketing.col.con_codigo')">
                                            <span class="mk-num">{{ cifra(f.con_codigo) }}</span>
                                            <span class="mk-bar" aria-hidden="true"><i :style="{ width: barra(f.con_codigo, 'con_codigo') }"></i></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p class="mk-foot">{{ $t('admin_marketing.table.foot') }}</p>
                    </section>
                </template>
            </section>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import HyFLoader from '@/components/Loader/HyFLoader.vue';
import ICON from '@/components/Cuenta/iconos';

const P = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
// Íconos: texto fijo de este archivo, nunca datos del usuario.
const IC = {
    back: P('<path d="M15 18l-6-6 6-6"/>'),
    search: ICON.search,
    mail: P('<rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="m3.5 7 8.5 6 8.5-6"/>'),
    check: P('<circle cx="10" cy="8" r="3.5"/><path d="M3.5 20a6.5 6.5 0 0 1 10.6-5"/><path d="m15.5 18 2 2 4-4"/>'),
    link: P('<path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1 1"/><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1-1"/>'),
    reload: P('<path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 5v6h-6"/>'),
    sort: P('<path d="m8 10 4-4 4 4M8 14l4 4 4-4"/>'),
};
const LOCALES = { es: 'es-CL', en: 'en-US', pt: 'pt-BR', fr: 'fr-FR', it: 'it-IT', de: 'de-DE' };
const PERIODOS = ['7d', '30d', '90d', 'mes', 'mes_anterior', 'todo'];
// Las claves de los textos no empiezan con número (vue-i18n).
const PER_KEY = { '7d': 'd7', '30d': 'd30', '90d': 'd90' };
const COLS = ['nombre', 'mail', 'elegido', 'con_codigo'];
const VACIO = { mail: { clics: 0, personas: 0, enviados: 0 }, elegido: 0, con_codigo: 0, partners: 0 };
const norm = s => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

export default {
    name: 'MarketingPartners',
    components: { HyFLoader },

    data() {
        const p = this.$route.query.periodo;
        return {
            IC, PERIODOS, COLS, PER_KEY,
            periodo: PERIODOS.includes(p) ? p : '30d',
            q: '',
            cargando: true, cargado: false, error: false, sinTabla: false,
            partners: [], tot: VACIO, desde: null, hasta: null,
            // Por defecto, los que más traen primero (elegidos).
            orden: { col: 'elegido', dir: -1 },
        };
    },

    computed: {
        loc() { return LOCALES[this.$i18n.locale] || 'es-CL'; },
        como() { return [{ k: 'mail', ic: IC.mail }, { k: 'picked', ic: IC.check }, { k: 'code', ic: IC.link }]; },
        valor() {
            return (f, c) => {
                if (c === 'nombre') return norm(f.nombre);
                if (c === 'mail') return f.mail ? f.mail.personas : -1;
                return f[c] || 0;
            };
        },
        filas() {
            const t = norm(this.q);
            const { col, dir } = this.orden;
            return this.partners
                .filter(f => !t || norm(f.nombre).includes(t))
                .slice()
                .sort((a, b) => {
                    const x = this.valor(a, col), y = this.valor(b, col);
                    if (x < y) return -dir;
                    if (x > y) return dir;
                    return norm(a.nombre) < norm(b.nombre) ? -1 : 1;
                });
        },
        // Máximo de cada columna para las barritas.
        maximos() {
            const m = { mail: 0, elegido: 0, con_codigo: 0 };
            this.partners.forEach(f => {
                m.mail = Math.max(m.mail, f.mail ? f.mail.personas : 0);
                m.elegido = Math.max(m.elegido, f.elegido || 0);
                m.con_codigo = Math.max(m.con_codigo, f.con_codigo || 0);
            });
            return m;
        },
        // "12 sep 2026 – 11 oct 2026" (hasta es exclusivo en la API).
        rangoTxt() {
            if (!this.desde || !this.hasta) return this.cargado ? this.$t('admin_marketing.range_all') : '';
            const f = s => { const [y, m, d] = s.split('-').map(Number); return new Date(y, m - 1, d); };
            const fin = f(this.hasta);
            fin.setDate(fin.getDate() - 1);
            const o = { day: 'numeric', month: 'short', year: 'numeric' };
            return this.$t('admin_marketing.range', { a: f(this.desde).toLocaleDateString(this.loc, o), b: fin.toLocaleDateString(this.loc, o) });
        },
    },

    created() {
        this.cargar();
    },

    methods: {
        cifra(n) { return Number(n || 0).toLocaleString(this.loc); },
        tasa(a, b) {
            if (!b) return '—';
            return (a / b).toLocaleString(this.loc, { style: 'percent', maximumFractionDigits: 1 });
        },
        barra(n, col) {
            const max = this.maximos[col];
            return max ? `${Math.max(n ? 4 : 0, Math.round((n / max) * 100))}%` : '0%';
        },
        inicial(s) { return (String(s || '?').trim()[0] || '?').toUpperCase(); },

        async cargar() {
            const req = (this._req = (this._req || 0) + 1);
            this.cargando = true;
            this.error = false;
            try {
                const { data } = await axios.get(`${process.env.VUE_APP_API_URL}admin/marketing/partners`, { params: { periodo: this.periodo } });
                if (req !== this._req) return;
                this.partners = Array.isArray(data.partners) ? data.partners : [];
                this.tot = { ...VACIO, ...(data.totales || {}), mail: { ...VACIO.mail, ...((data.totales && data.totales.mail) || {}) } };
                this.desde = data.desde || null;
                this.hasta = data.hasta || null;
                this.sinTabla = !!data.sin_tabla;
                this.cargado = true;
            } catch (e) {
                if (req !== this._req) return;
                console.error('[Marketing] No se pudieron cargar los partners', e);
                this.error = true;
            } finally {
                if (req === this._req) this.cargando = false;
            }
        },
        elegirPeriodo(p) {
            if (p === this.periodo) return;
            this.periodo = p;
            const query = { ...this.$route.query };
            if (p === '30d') delete query.periodo; else query.periodo = p;
            this.$router.replace({ query }).catch(() => {});
            this.cargar();
        },
        ordenar(c) {
            if (this.orden.col === c) this.orden = { col: c, dir: -this.orden.dir };
            else this.orden = { col: c, dir: c === 'nombre' ? 1 : -1 };
        },
    },
};
</script>

<style src="../../BankInformation/bkCuenta.css"></style>
<style src="../../Cuenta/cuentaMenu.css"></style>
<style src="../Usuarios/usuariosAdmin.css"></style>
<style src="./marketingAdmin.css"></style>
